module.exports = __webpack_public_path__ + "media/images/lock-54cad66bc6cd4925c32672868563ca7a.svg";